import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { tmOAuthConfig } from "../provider/models/tm-oauth-config";
import { tmAuthConfig } from "../provider/models/tm-auth-config.model";
import { TMOauthService } from "../provider/service/tm-oauth.service";
import { TMAuthService } from "../provider/service/tm-auth.service";
import { TMAuthProviderConfig } from "./models/tm-auth.model";



/**
 * Provides the TM Auth services
 * should be provided in the root module
 * @example
 *  providers: [
 *      provideTMAuth({
 *           ssoAuth: tmSSOAuthConfig,
 *           loginAuth: tmLoginAuthConfig
 *       }),
 *    ...
 *   ]
 * 
 */
export function provideTMAuth(config: TMAuthProviderConfig): EnvironmentProviders{
    return makeEnvironmentProviders([    
        TMOauthService,
        TMAuthService,
        {
            provide: tmOAuthConfig,
            useValue: config.ssoAuth
        },
        {
            provide: tmAuthConfig,
            useValue: config.loginAuth
        },
    ])
}